<template>
  <NavBar />
  <main class="exercises-page">
    <div class="container exercises-container">
      <header class="page-header">
        <router-link :to="{ name: 'Excercise' }" class="back-button"><i class="bi bi-arrow-left" aria-hidden="true"></i>Tüm egzersizler</router-link>
        <span class="eyebrow">KEŞFET, PRATİK YAP, GELİŞTİR</span>
        <h1>Okuma ve Dinleme</h1>
        <p>Günlük hayattan konularla okuma ve dinleme becerilerini geliştir.</p>
      </header>

      <section v-if="!showDetail" aria-labelledby="categories-title">
        <div class="section-header">
          <h2 id="categories-title">Bir konu seç</h2>
          <span class="count-badge">{{ dialogAndListening.length }} kategori</span>
        </div>
        <div class="category-grid">
          <button v-for="category in dialogAndListening" :key="category.id" type="button" class="category-card" @click="GetCategory(category.id)">
            <span class="category-image"><img :src="require('@/assets/images/excercises/' + category.image)" alt="" loading="lazy" /></span>
            <span class="category-copy"><span class="category-title">{{ category.label }}</span><span class="category-link">Egzersizleri keşfet</span></span>
            <i class="bi bi-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </section>

      <section v-else aria-labelledby="category-title">
        <button type="button" class="back-button" @click="showDetail = false"><i class="bi bi-arrow-left" aria-hidden="true"></i>Tüm kategoriler</button>
        <div class="exercise-panel" :aria-busy="isLoading">
          <header class="list-header">
            <div><h2 id="category-title">{{ selectedCategoryTitle }}</h2><p>Bir egzersiz seç, kendi hızında pratik yap.</p></div>
            <span v-if="!isLoading && !loadError" class="count-badge">{{ exercises.length }} egzersiz</span>
          </header>
          <div v-if="isLoading" class="list-state" role="status"><span class="spinner-border" aria-hidden="true"></span><p>Egzersizler yükleniyor…</p></div>
          <div v-else-if="loadError" class="list-state" role="alert"><i class="bi bi-exclamation-circle" aria-hidden="true"></i><h3>Egzersizler yüklenemedi</h3><p>Lütfen tekrar deneyin.</p><button type="button" class="exercise-button" @click="GetCategory(selectedCategory)">Tekrar dene</button></div>
          <div v-else-if="!exercises.length" class="list-state" role="status"><i class="bi bi-journal-text" aria-hidden="true"></i><h3>Henüz egzersiz bulunmuyor</h3><p>Pratik yapmak için başka bir konu seçebilirsin.</p></div>
          <ul v-else class="exercise-list">
            <li v-for="exercise in exercises" :key="exercise.id || exercise.sequence" class="exercise-row">
              <span class="unit-number" aria-hidden="true">{{ exercise.sequence }}</span>
              <div class="exercise-info"><span class="unit-label">Ünite {{ exercise.sequence }}</span><h3>{{ exercise.title }}</h3></div>
              <button type="button" class="exercise-button" :aria-label="exercise.title + ' egzersizine başla'" @click="OpenCloseExcerciseModal(true, exercise.title, exercise.sequence, exercise.content, exercise.isImage, exercise.isSound, exercise.isTranslate)">Başla<i class="bi bi-arrow-right" aria-hidden="true"></i></button>
            </li>
          </ul>
        </div>
      </section>
    </div>
  </main>
  <FooterInPage />
  <ExcerciseModal
    :Title="selectedExercise.title"
    :Category="selectedCategory"
    :Sequence="selectedExercise.sequence"
    :Content="selectedExercise.content"
    :IsImage="selectedExercise.isImage"
    :IsAudio="selectedExercise.isAudio"
    :IsTranslate="selectedExercise.isTranslate"
    :Visible="excerciseModalVisible"
    @CloseModal="OpenCloseExcerciseModal($event, '', 0, '', false, false, false)" />
</template>

<script>
import { mapActions } from 'vuex';
import NavBar from '@/components/Shared/NavBar.vue';
import FooterInPage from '@/components/Shared/FooterInPage.vue';
import ExcerciseModal from '@/components/Modals/ExcerciseModal.vue';
import { GetExercisesCategory } from '@/common/test-helper';
import { LoadingToast, UpdateToast, ToastType } from '@/common/notification.js';

export default {
  name: 'ExercisePage',
  components: { NavBar, FooterInPage, ExcerciseModal },
  data() {
    return {
      showDetail: false,
      selectedCategory: 0,
      selectedCategoryTitle: '',
      selectedExercise: { title: '', sequence: 0, content: '', isImage: false, isAudio: false, isTranslate: false },
      excerciseModalVisible: false,
      dialogAndListening: [],
      exercises: [],
      isLoading: false,
      loadError: false,
      requestId: 0
    };
  },
  methods: {
    ...mapActions(['GetExercises']),
    async GetCategory(value) {
      const category = this.dialogAndListening.find(item => item.id === value);
      if (!category) return;
      this.showDetail = true;
      this.selectedCategory = value;
      this.selectedCategoryTitle = category.label;
      this.exercises = [];
      this.isLoading = true;
      this.loadError = false;
      const requestId = ++this.requestId;
      const toastId = LoadingToast();
      try {
        const res = await this.GetExercises(value);
        if (requestId === this.requestId) this.exercises = res;
        UpdateToast(toastId, res.description, ToastType().SUCCESS, 100);
      } catch (err) {
        if (requestId === this.requestId) this.loadError = true;
        UpdateToast(toastId, err.message, ToastType().ERROR);
      } finally {
        if (requestId === this.requestId) this.isLoading = false;
      }
    },
    OpenCloseExcerciseModal(visible, title, sequence, content, isImage, isAudio, isTranslate) {
      this.selectedExercise = { title, sequence, content, isImage, isAudio, isTranslate };
      this.excerciseModalVisible = visible;
    }
  },
  mounted() {
    this.dialogAndListening = GetExercisesCategory();
    if (this.$route.query.q) this.GetCategory(parseInt(this.$route.query.q, 10));
  }
};
</script>

<style scoped>
.exercises-page { background: #f7f9f7; color: #24382e; padding: 48px 0 64px; min-height: 70vh; }
.exercises-container { max-width: 1120px; }
.page-header { margin-bottom: 36px; }
.eyebrow { display: block; color: var(--brand-link); font-size: .72rem; font-weight: 700; letter-spacing: .12em; margin-bottom: 12px; }
.page-header h1 { font-size: clamp(2rem, 4vw, 2.6rem); font-weight: 700; letter-spacing: -.035em; margin-bottom: 12px; }
.page-header p { color: #637269; line-height: 1.7; margin: 0; }
.section-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; margin-bottom: 18px; }
.section-header h2 { font-size: 1.1rem; font-weight: 600; margin: 0; }
.count-badge { flex-shrink: 0; border-radius: 20px; padding: 6px 12px; background: #edf5eb; color: var(--brand-link); font-size: .75rem; font-weight: 600; }
.category-grid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 16px; }
.category-card { display: flex; align-items: center; gap: 16px; padding: 22px 18px; border: 1px solid #e4eae4; border-radius: 16px; background: #fff; color: #24382e; text-align: left; transition: border-color .18s, background-color .18s; }
.category-card:hover { border-color: #aac5ab; background: #fcfdfb; }
.category-image { display: flex; align-items: center; justify-content: center; flex-shrink: 0; width: 64px; height: 64px; padding: 6px; border-radius: 14px; background: #f4f7f1; }
.category-image img { width: 100%; height: 100%; object-fit: contain; }
.category-copy { flex: 1; min-width: 0; }
.category-title { display: block; font-size: .95rem; font-weight: 600; line-height: 1.5; overflow-wrap: anywhere; }
.category-link { display: block; margin-top: 6px; font-size: .76rem; color: #637269; }
.category-card > i { color: var(--brand-link); flex-shrink: 0; }
.back-button { display: inline-flex; align-items: center; gap: 8px; min-height: 44px; padding: 0 4px; margin-bottom: 16px; border: 0; background: transparent; color: var(--brand-link); font-size: .85rem; font-weight: 600; }
.back-button:hover { color: #24382e; }
.back-button { text-decoration: none; }
.back-button:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
.exercise-panel { background: #fff; border: 1px solid #e4eae4; border-radius: 18px; overflow: hidden; }
.list-header { display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 26px; border-bottom: 1px solid #edf0ed; }
.list-header h2 { font-size: 1.2rem; font-weight: 700; margin: 0 0 8px; overflow-wrap: anywhere; }
.list-header p { margin: 0; font-size: .85rem; color: #637269; line-height: 1.7; }
.exercise-list { list-style: none; padding: 0; margin: 0; }
.exercise-row { display: flex; align-items: center; gap: 16px; padding: 22px 26px; }
.exercise-row + .exercise-row { border-top: 1px solid #edf0ed; }
.exercise-row:hover { background: #fcfdfb; }
.unit-number { display: flex; align-items: center; justify-content: center; min-width: 44px; height: 48px; padding: 8px; border-radius: 12px; background: #f2f6ef; color: var(--brand-link); font-size: 1rem; font-weight: 600; }
.exercise-info { flex: 1; min-width: 0; }
.unit-label { display: block; color: #637269; font-size: .75rem; margin-bottom: 5px; }
.exercise-info h3 { font-size: .95rem; font-weight: 600; line-height: 1.5; margin: 0; overflow-wrap: anywhere; }
.exercise-button { display: inline-flex; align-items: center; justify-content: center; gap: 10px; flex-shrink: 0; min-height: 44px; padding: 10px 16px; border: 0; border-radius: 9px; background: var(--brand-link); color: #fff; font-size: .82rem; font-weight: 600; }
.exercise-button:hover { background: var(--brand-primary-hover); }
.exercises-page button:focus-visible { outline: 3px solid var(--brand-link); outline-offset: 3px; }
.list-state { padding: 60px 24px; text-align: center; color: #637269; }
.list-state > i { display: block; font-size: 2rem; color: var(--brand-link); margin-bottom: 16px; }
.list-state .spinner-border { color: var(--brand-link); margin-bottom: 16px; }
.list-state h3 { font-size: 1rem; font-weight: 600; color: #24382e; }
.list-state p { font-size: .88rem; line-height: 1.7; margin: 0; }
.list-state button { margin-top: 20px; }
@media (max-width: 991.98px) {
  .category-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 575.98px) {
  .exercises-page { padding: 32px 0 40px; }
  .page-header { margin-bottom: 28px; }
  .category-grid { grid-template-columns: minmax(0, 1fr); gap: 12px; }
  .category-card { padding: 16px; }
  .category-image { width: 56px; height: 56px; }
  .list-header { align-items: flex-start; flex-direction: column; padding: 20px; }
  .exercise-row { flex-wrap: wrap; gap: 12px; padding: 20px; }
  .exercise-info { flex-basis: calc(100% - 60px); }
  .exercise-row .exercise-button { margin-left: 56px; flex: 1; }
}
@media (prefers-reduced-motion: reduce) {
  .category-card { transition: none; }
}
</style>
